import { render, staticRenderFns } from "./Overall.vue?vue&type=template&id=4a08a598&"
import script from "./Overall.vue?vue&type=script&lang=js&"
export * from "./Overall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports